"use strict";

import angular from "angular";

import template from "./sidebar-navigation.component.html";
import "./themes/sidebar-navigation.component.scss";

import _ from "lodash";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { Events } from "../../../presentation/services/Events/Events";

const version = require("../../../../public/js/version");

export class SidebarNavigationComponent {
    constructor(
        $transitions,
        $location,
        $state,
        $stateParams,
        $scope,
        NavigationService,
        AccountingFactory,
        JWTService,
        LayoutService,
        CentralSidenavService,
        UserProfileSidenavService,
        CompanyDataService
    ) {
        this.$transitions = $transitions;
        this.$location = $location;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.NavigationService = NavigationService;
        this.AccountingFactory = AccountingFactory;
        this.JWTService = JWTService;
        this.LayoutService = LayoutService;
        this.CentralSidenavService = CentralSidenavService;
        this.UserProfileSidenavService = UserProfileSidenavService;
        this.CompanyDataService = CompanyDataService;
        this.version = version;
        this.Events = new Events();
    }

    $onInit() {
        this.NavigationService.setValidations();

        this.NavigationService.setAvailables(this.$state.current.name);

        this.NavigationService.setParams("source", "contabil");

        this.NavigationService.setParams("id", this.$state.params.id);

        this.NavigationService.setHref();

        this.$transitions.onStart({}, (transition) => {
            this.NavigationService.setAvailables(transition.to().name);
        });
        this.toggleClass();
        this.$scope.$on("$destroy", () => {
            this.toggleClass();
        });

        this.user = new UserDataAdapter().user();

        this.isBusinessman = _.get(this.user, "roles").includes("Empresa");
    }

    /**
     * O item de menu fica disponível já no `onStart` da transição, quando
     * `$state.params` ainda é o da rota anterior — de nível contabilidade, que
     * tem `accountingId` mas não `id`. Por isso o `customHref` saía com
     * `empresa/undefined`. A URL sempre carrega `/empresa/<id>`, então ela é a
     * fonte confiável nesse momento.
     */
    getCompanyId() {
        const [, idFromUrl] =
            /\/empresa\/([^/?#]+)/.exec(this.$location.path()) || [];
        return this.$state.params.id || idFromUrl || null;
    }

    getAccountingId() {
        return this.$state.params.accountingId;
    }

    toggleClass() {
        angular
            .element(document.getElementsByTagName("body"))
            .toggleClass("sidebar-navigation-active");
    }

    toggleOpenMenu() {
        angular
            .element(document.getElementById("SidebarNavigation"))
            .toggleClass("sidebar-navigation__opened");
    }

    /**
     * @public
     * Faz logout
     */
    logout = () => {
        this.JWTService.signout();
    };

    /**
     * @public
     * @description - Faz o redirecionamento para empresas
     */
    onGetCompanyRedirect = () => {
        if (
            this.$state.current.name.indexOf("nucont.accounting.overview") ===
            -1
        ) {
            const accountingId = this.AccountingFactory.getId();

            return this.$state.href(
                "nucont.accounting.overview.portfolio.companies.resume",
                {
                    accountingId
                }
            );
        }
    };

    cancelRedirect(item) {
        if (!item.cancelredirect) return false;
        return item.cancelredirect.includes(this.$state.current.name);
    }

    hasVisibleSubmenu(item) {
        if (!item.submenu || item.submenu.length === 0) return false;
        return item.submenu.some(
            (sub) => !sub.hidden && sub.contracted && sub.show
        );
    }

    toggleSubmenu(item) {
        item.expanded = !item.expanded;
    }

    onOpenCentralHelper() {
        this.CentralSidenavService.open(0);
    }

    onOpenCentralNews() {
        this.CentralSidenavService.open(1);
    }

    onOpenProfileMenu() {
        this.UserProfileSidenavService.open();
    }
}

SidebarNavigationComponent.$inject = [
    "$transitions",
    "$location",
    "$state",
    "$stateParams",
    "$scope",
    "NavigationService",
    "AccountingFactory",
    "JWTService",
    "LayoutService",
    "CentralSidenavService",
    "UserProfileSidenavService",
    "CompanyDataService"
];

const name = "sidebarNavigationComponent";
const def = {
    controller: SidebarNavigationComponent,
    bindings: {},
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
